import React from 'react';
import Select from 'react-select';
import { FaTimes } from 'react-icons/fa';
import DateTimePicker from 'react-datetime-picker';
import LastDayOfMonth from 'date-fns/lastDayOfMonth';
import Moment from 'moment';

import DateUtil from '../../util/Util';
import Const from '../../util/Constants';
import FieldController from '../../controller/FieldController';

import './Filter.css';

class FilterDate extends React.Component {

  constructor(props) {
    super(props);
    const filter = props.filter;
    this.conditions = FieldController.getConditions(props.field.field_type);
    let condition = filter ? filter.condition : FieldController.In;
    condition = this.conditions.find(item => condition === item.value);
    let from = null, to = null;
    if(filter && filter.value !== '') {
      let values = props.filter.value.split(Const.Opt);
      if(values[0] !== '') {
        from = DateUtil.serverStringDateTimeToDate(values[0]);
      }
      if(values[1] !== '') {
        to = DateUtil.serverStringDateTimeToDate(values[1]);
      }
    }
    this.state = { condition: condition, from, to };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if(props.field.field_key !== this.props.field.field_key) {
      const filter = props.filter;
      let condition = filter ? filter.condition : FieldController.In;
      condition = this.conditions.find(item => condition === item.value);
      
      let from = null, to = null; 
      if(filter && filter.value !== '') {
        let values = props.filter.value.split(Const.Opt);
        if(values[0] !== '') {
          from = DateUtil.serverStringDateTimeToDate(values[0]);
        }
        if(values[1] !== '') {
          to = DateUtil.serverStringDateTimeToDate(values[1]);
        }
      }
      this.setState({ ...this.state, condition, from, to });
    }
  }

  onConditionChanged = select => {
    let value = select.value;
    let from = null;
    let to = null;
    if(value === FieldController.Today || value === FieldController.Tomorrow
      || value === FieldController.Yesterday 
      || value === FieldController.ThisMonth || value === FieldController.NextMonth 
      || value === FieldController.LastMonth 
      || value === FieldController.Last90Days 
      || value === FieldController.Next7Days  || value === FieldController.Last7Days
      || value === FieldController.Next15Days || value === FieldController.Last15Days
      || value === FieldController.ThisYear || value === FieldController.LastYear || value === FieldController.NextYear) {
      value = FilterDate.getValue(value);
      select = this.conditions.find(item => FieldController.In === item.value);
      let values = value.split(Const.Opt);
      if(values[0] !== '') {
        from = DateUtil.serverStringDateTimeToDate(values[0]);
      }
      if(values[1] !== '') {
        to = DateUtil.serverStringDateTimeToDate(values[1]);
      }
    }

    this.setState({ ...this.state, condition: select, from: from, to: to });
    if(select.value === FieldController.Empty || select.value === FieldController.NotEmpty) {
      this.props.onValueChange(this.props.field.field_key, select.value, '', this.props.field.model_key);
    } else if(from || to) {
      this.props.onValueChange(this.props.field.field_key, select.value, value, this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.field_key, this.props.field.model_key);
    }
  }

  handleDateChange = (date, source) => {
    let value = '';
    if(source === 'from') {
      if(date) { date.setHours(0); date.setMinutes(0); }
      value = date ? `${DateUtil.dateToServerDateTime(date)}${Const.Opt}` : Const.Opt;
      value = this.state.to ? `${value}${DateUtil.dateToServerDateTime(this.state.to)}` : value;
      this.setState({ ...this.state, from: date });
    } else if(source === 'to') {
      if(date) { date.setHours(23); date.setMinutes(59); }
      value = this.state.from ? `${DateUtil.dateToServerDateTime(this.state.from)}${Const.Opt}`
        : Const.Opt;
      value = date ? `${value}${DateUtil.dateToServerDateTime(date)}` : value;
      this.setState({ ...this.state, to: date });
    }
    if(value !== Const.Opt) {
      this.props.onValueChange(this.props.field.field_key, this.state.condition.value, value, this.props.field.model_key);
    } else {
      this.props.deleteFilter(this.props.field.field_key, this.props.field.model_key);
    }
  }

  render() {
    const condition = this.state.condition ? this.state.condition.value : '';
    const isFilter = (this.state.from || this.state.to )
      || !(FieldController.showDateFrom(Const.Date, condition)
        && FieldController.showDateTo(Const.Date, condition));
    return (
      <>
        <div className="row pt-2">
          <div className="col-md-5">
            <p className="headingp">
            {this.props.field.model_key ? <>{this.props.field.model_name}<br/></> : ''}{this.props.field.label_name}
            </p>
          </div>
          <div className={`col-md-${isFilter ? 5: 7}`}>
            <Select value={this.state.condition} onChange={this.onConditionChanged}
              options={this.conditions} isSearchable={true} />
          </div>
          { isFilter ? <div className="col-md-1"><FaTimes 
              onClick={() => this.props.resetFilter(this.props.field.field_key)}/></div> : null }
        </div>

        <div className="row pt-2">
          <div className="col-md-12">
            { FieldController.showDateFrom(Const.Date, condition) ?
              <DateTimePicker className="col-md-6" value={this.state.from} format="dd-MM-y"
                onChange={(date) => this.handleDateChange(date, 'from')} /> : null
            }
          </div>
          <div className="col-md-12">
            { FieldController.showDateTo(Const.Date, condition) ?
              <DateTimePicker className="col-md-6" value={this.state.to} format="dd-MM-y"
                onChange={(date) => this.handleDateChange(date, 'to')} /> : null
            }
          </div>
        </div>
        <hr />
      </>
    );
  }

  static getValue = (value, condition) => {
    let date = new Date();
    if(value === FieldController.Today) {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.Tomorrow) {
      date.setDate(date.getDate() + 1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.Yesterday) {
      date.setDate(date.getDate() - 1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.ThisWeek) {
      date.setDate(date.getDate() - date.getDay());
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date.setDate(date.getDate() + 6);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.NextWeek) {
      date.setDate(date.getDate() - date.getDay() + 7);
      date.setHours(0);
      date.setMinutes(0);
      value = DateUtil.dateToServerDateTime(date);
      date.setDate(date.getDate() + 6);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.LastWeek) {
      date.setDate(date.getDate() - date.getDay() - 7);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date.setDate(date.getDate() + 6);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.ThisMonth) {
      date.setDate(1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date = LastDayOfMonth(date);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.NextMonth) {
      date.setMonth(date.getMonth() + 1);
      date.setDate(1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date = LastDayOfMonth(date);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.LastMonth) {
      date.setMonth(date.getMonth() - 1);
      date.setDate(1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date = LastDayOfMonth(date);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.Last90Days) {
      date.setDate(date.getDate() - 90);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date = new Date();
      date.setDate(date.getDate() - 1);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.Next7Days) {
      date = new Date()
      date.setDate(date.getDate() + 1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date.setDate(date.getDate() + 7);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.Last7Days) {
      date = new Date();
      date.setDate(date.getDate() - 7);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date = new Date();
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.Next15Days) {
      date = new Date()
      date.setDate(date.getDate() + 1);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date.setDate(date.getDate() + 15);
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.Last15Days) {
      date.setDate(date.getDate() - 15);
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date = new Date()
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.ThisYear) {
      date.setDate(1);
      date.setMonth(0);
      date.setHours(0);
      date.setMinutes(0);
      value = DateUtil.dateToServerDateTime(date);
      date = new Date();
      date.setDate(31);
      date.setMonth(11);
      date.setHours(23);
      date.setMinutes(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.LastYear) {
      date.setDate(1);
      date.setMonth(0);
      date.setFullYear(date.getFullYear() - 1);
      date.setHours(0);
      date.setMinutes(0);
      value = DateUtil.dateToServerDateTime(date);
      date = new Date();
      date.setDate(31);
      date.setMonth(11);
      date.setFullYear(date.getFullYear() - 1);
      date.setHours(23);
      date.setMinutes(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.NextYear) {
      date.setDate(1);
      date.setMonth(0);
      date.setFullYear(date.getFullYear() + 1);
      date.setHours(0);
      date.setMinutes(0);
      value = DateUtil.dateToServerDateTime(date);
      date = new Date();
      date.setDate(31);
      date.setMonth(11);
      date.setFullYear(date.getFullYear() + 1);
      date.setHours(23);
      date.setMinutes(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.NumberOfMinutes)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().subtract(value[1], 'minutes').set({ second: 0, millisecond: 0 }).toDate();
      } else {
        date = Moment().add(value[1], 'minutes').set({ second: 0, millisecond: 0 }).toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.NumberOfHours)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().subtract(value[1], 'hours').set({ minute: 0, second: 0, millisecond: 0 }).toDate();
      } else {
        date = Moment().add(value[1], 'hours').set({ minute: 0, second: 0, millisecond: 0 }).toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.NumberOfDays)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().subtract(value[1], 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      } else {
        date = Moment().add(value[1], 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.NumberOfWeeks)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().subtract(value[1], 'weeks').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      } else {
        date = Moment().add(value[1], 'weeks').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.NumberOfMonths)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().subtract(value[1], 'months').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      } else {
        date = Moment().add(value[1], 'months').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.NumberOfYears)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().subtract(value[1], 'years').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      } else {
        date = Moment().add(value[1], 'years').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.StartOfWeek)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().startOf('week').subtract(value[1], 'weeks').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      } else {
        date = Moment().startOf('week').add(value[1], 'weeks').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.StartOfMonth)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().startOf('month').subtract(value[1], 'months').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      } else {
        date = Moment().startOf('month').add(value[1], 'months').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.StartOfYear)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().startOf('year').subtract(value[1], 'years').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      } else {
        date = Moment().startOf('year').add(value[1], 'years').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    }  else if(value && value.includes(FieldController.EndOfWeek)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().endOf('week').subtract(value[1], 'weeks').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      } else {
        date = Moment().endOf('week').add(value[1], 'weeks').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.EndOfMonth)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().endOf('month').subtract(value[1], 'months').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      } else {
        date = Moment().endOf('month').add(value[1], 'months').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value && value.includes(FieldController.EndOfYear)) {
      value = value.split(Const.Opt);
      if(value[1].includes('-')) {
        value[1] = value[1].replace('-', '');
        date = Moment().endOf('year').subtract(value[1], 'years').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      } else {
        date = Moment().endOf('year').add(value[1], 'years').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
          .toDate();
      }
      value = condition === 'start-with' ? DateUtil.dateToServerDateTime(date) + Const.Opt
        : Const.Opt + DateUtil.dateToServerDateTime(date);
    } else if(value === FieldController.YearlyThisMonth
      || value === FieldController.YearlyThisDay) {
      date = new Date();
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      value = DateUtil.dateToServerDateTime(date);
      date = new Date();
      date.setHours(23);
      date.setMinutes(59);
      date.setSeconds(59);
      value += Const.Opt + DateUtil.dateToServerDateTime(date);
    } 
    return value;
  }
}

export default FilterDate;